export default {"src":"/_next/static/media/redact-flow-chart.7eb56ec8.svg","height":450,"width":602,"blurWidth":0,"blurHeight":0};